import { createApi } from "@reduxjs/toolkit/query/react"
import { axiosBaseQuery } from "../shared/utility/axios-base-query"

// initialize an empty api service that we'll inject endpoints into later as needed
export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "Owner",
    "Owners",
    "Archived Owner",
    "Archived Owners",
    "Count Owners",
    "Request",
    "Requests",
    "Count Requests",
    "Property",
    "Properties",
    "Count Properties",
    "Unit of Properties",
    "Count Unit of Properties",
    "Count Dashboard Properties",
    "Count Dashboard Owners",
    "Count Dashboard Units",
    "Count Dashboard Tenants",
    "Count Dashboard Leases",
    "Count Dashboard Requests",
    "Tenant",
    "Tenants",
    "Count Tenants",
    "Archived Tenant",
    "Archived Tenants",
    "Leases",
    "Lease",
    "Count Leases",
    "Archived Leases",
    "Archived Lease",
    "Units Of Lease",
    "Rent Increases",
    "Rent Increase",
    "Notification Properties",

    "Sale",
    "Sales",
    "Archived Sale",
    "Archived Sales",
    "Count Sales",

    "Payment",
    "Payments",
    "Count Payments",

    "Archived Payment",
    "Archived Payments",

    "Parking Lot",
    "Parking Lots",
    "Archived Parking Lot",
    "Archived Parking Lots",
    "Count Parking Lots",

    "Parking Activity",
    "Parking Activities",
    "Archived Parking Activity",
    "Archived Parking Activities",
    "Count Parking Activities",

    "Owner Settings",
  ],
  endpoints: () => ({}),
})
